export const globalGetters = {
  teachers: 'teacher/teachers'
}

export const getters = {
  teachers: state => state.teachers
}
